import { supabase } from './supabase'
import { getDeviceId, arrondiQty } from './api'

function nouveauClientUid() {
  return getDeviceId() + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8)
}

export async function getProduitsCaissier(boutiqueId) {
  const { data, error } = await supabase.rpc('get_produits_boutique', {
    p_boutique_id: boutiqueId
  })
  return { data, error }
}

// Mouvement atomique — même garanties que côté patron
export async function enregistrerMouvementCaissier(boutiqueId, { produitId, type, quantite, note, clientUid }) {
  const { data, error } = await supabase.rpc('add_mouvement_caissier', {
    p_boutique_id: boutiqueId,
    p_produit_id:  produitId,
    p_type:        type,
    p_quantite:    arrondiQty(quantite),
    p_note:        note || null,
    p_client_uid:  clientUid || nouveauClientUid()
  })
  if (error) return { error }
  const res = data?.[0]
  if (res?.erreur) return { error: { message: res.erreur } }
  return { data: { id: res?.mouvement_id }, nouvelleQty: res?.nouvelle_qty, error: null }
}

export async function addProduitCaissier(boutiqueId, produit) {
  const { data, error } = await supabase.rpc('add_produit_caissier', {
    p_boutique_id:     boutiqueId,
    p_nom:             produit.nom,
    p_categorie:       produit.categorie,
    p_quantite:        produit.quantite,
    p_unite:           produit.unite,
    p_prix_unitaire:   produit.prix_unitaire,
    p_seuil_alerte:    produit.seuil_alerte,
    p_prix_achat:      produit.prix_achat || 0,
    p_est_perissable:  produit.est_perissable || false,
    p_date_peremption: produit.date_peremption || null,
    p_duree_vie_jours: produit.duree_vie_jours || null
  })
  return { data, error }
}

export async function deleteProduitCaissier(boutiqueId, produitId) {
  const { data, error } = await supabase.rpc('delete_produit_caissier', {
    p_boutique_id: boutiqueId,
    p_produit_id: produitId
  })
  return { data, error }
}

export async function getMouvementsCaissier(boutiqueId, limite = 50) {
  const { data, error } = await supabase.rpc('get_mouvements_boutique', {
    p_boutique_id: boutiqueId,
    p_limite: limite
  })
  return { data, error }
}
